import { PageHeader, Panel } from "@/components/common";
import { Waveform, VideoCamera, ChatText, SpeakerHigh, MusicNotes, TextT, Scissors, ArrowsOutLineHorizontal } from "@phosphor-icons/react";
import { toast } from "sonner";

const TRACKS = [
  { name: "VIDEO", icon: VideoCamera, color: "#00E5FF", clips: [] },
  { name: "DIALOGUE", icon: ChatText, color: "#FF007F", clips: [] },
  { name: "SFX", icon: SpeakerHigh, color: "#FFB800", clips: [] },
  { name: "MUSIC", icon: MusicNotes, color: "#00FF9D", clips: [] },
  { name: "SUBTITLES", icon: TextT, color: "#8B5CF6", clips: [] },
];
const TOOLS = ["Trim", "Split", "Delete", "Move", "Extend", "Shorten", "Volume", "Fade", "Transitions", "Text"];

export default function TimelineEditor() {
  return (
    <div>
      <PageHeader icon={Waveform} title="Timeline Video Editor"
        subtitle="An integrated visual editor — simpler than desktop software, still powerful. Advanced editing has an enhanced desktop layout." />
      <Panel className="mb-4"><p className="text-sm text-zinc-400">No media loaded. Open a real PinPilot clip from the Media Library to begin editing.</p></Panel>

      <Panel className="mb-4">
        <div className="flex flex-wrap gap-2">
          {TOOLS.map((t) => (
            <button key={t} data-testid={`tl-tool-${t}`} onClick={() => toast(`${t}: applies to selected clip (Phase 2 export).`)}
              className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-[#1C1C1C] px-3 py-1.5 text-xs text-white hover:border-[#00E5FF]/40 transition-colors">
              {t === "Trim" && <Scissors size={13} weight="duotone" />}{t}
            </button>
          ))}
        </div>
      </Panel>

      <Panel className="overflow-x-auto">
        <div className="min-w-[720px]">
          <div className="flex items-center gap-2 mb-3 pl-28">
            {Array.from({ length: 9 }).map((_, i) => (
              <span key={i} className="font-mono text-[10px] text-zinc-600 w-[11.1%] shrink-0">{i * 10}s</span>
            ))}
          </div>
          <div className="space-y-2">
            {TRACKS.map((tr) => {
              const Icon = tr.icon;
              return (
                <div key={tr.name} className="flex items-center gap-3">
                  <div className="w-28 shrink-0 flex items-center gap-2 text-xs text-zinc-400">
                    <Icon size={15} weight="duotone" style={{ color: tr.color }} /> {tr.name}
                  </div>
                  <div className="relative flex-1 h-10 rounded-lg bg-black/30 border border-white/5">
                    {tr.clips.map(([start, end], i) => (
                      <div key={i} data-testid={`tl-clip-${tr.name}-${i}`}
                        className="absolute top-1 bottom-1 rounded-md border cursor-pointer hover:brightness-125 transition-all flex items-center justify-between px-1.5"
                        style={{ left: `${start / 80 * 100}%`, width: `${(end - start) / 80 * 100}%`, background: `${tr.color}22`, borderColor: `${tr.color}66` }}>
                        <ArrowsOutLineHorizontal size={10} style={{ color: tr.color }} className="opacity-0 group-hover:opacity-100" />
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-3 relative pl-28">
            <div className="absolute top-0 bottom-0 w-0.5 bg-[#00E5FF]" style={{ left: "35%" }} />
          </div>
        </div>
      </Panel>
    </div>
  );
}
